import { render } from "./DialogCompletaScadenzaMezzo.vue?vue&type=template&id=ddf8bd72"
import script from "./DialogCompletaScadenzaMezzo.vue?vue&type=script&lang=js"
export * from "./DialogCompletaScadenzaMezzo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__